module.exports = __webpack_public_path__ + "static/img/advance.06b0f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/researchSystem/images/advance.png
// module id = kzZ7
// module chunks = 0